function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E2F5F6",
    style: {
      fill: "#E2F5F6",
      fill: "color(display-p3 0.8871 0.9592 0.9663)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27821_143648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 30C14.477 30 10 25.523 10 20C10 14.477 14.477 10 20 10C25.523 10 30 14.477 30 20C30 25.523 25.523 30 20 30ZM20 28C22.1217 28 24.1566 27.1571 25.6569 25.6569C27.1571 24.1566 28 22.1217 28 20C28 17.8783 27.1571 15.8434 25.6569 14.3431C24.1566 12.8429 22.1217 12 20 12C17.8783 12 15.8434 12.8429 14.3431 14.3431C12.8429 15.8434 12 17.8783 12 20C12 22.1217 12.8429 24.1566 14.3431 25.6569C15.8434 27.1571 17.8783 28 20 28ZM19.003 24L14.76 19.757L16.174 18.343L19.003 21.172L24.659 15.515L26.074 16.929L19.003 24Z",
    fill: "#6FCBD4",
    style: {
      fill: "#6FCBD4",
      fill: "color(display-p3 0.4353 0.7961 0.8314)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27821_143648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(8 8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.baa0f14b46577309f39f1fca89d61367.svg";
export { ForwardRef as ReactComponent };